/**
 * Fusion Eat moved to its own site, the Fusion Meals admin (admin.fusion-eat.com,
 * 16 Oct 2026). /meals stays as an address so bookmarks and old e-mail links
 * still land there. The screens themselves (views/meals/) are built into that
 * site from this project: src/fusion-admin/.
 */
import { MEALS_ADMIN_URL } from "@/config/mealsAdmin.js";

const mealsRoutes = [
  {
    path: "/meals",
    name: "MealsMoved",
    meta: { public: true },
    beforeEnter: () => {
      window.location.assign(MEALS_ADMIN_URL);
      return false;
    },
    component: { render: () => null },
  },
];

export default mealsRoutes;
